import React, {FunctionComponent} from "react"

interface RadioInputProps {
	name: string
	title: string
	disabled?: boolean
	register: any
	value: string
}

const RadioInput: FunctionComponent<RadioInputProps> = ({
	title,
	name,
	disabled = false,
	register,
	value
}) => {
	return (
		<div className='field-radio-input'>
			<label htmlFor={title}>{title}</label>
			<input type='radio' value={value} id={title} name={name} disabled={disabled} {...register(name)} />
		</div>
	)
}

export default RadioInput
